import {Component, OnInit, ViewChild} from '@angular/core';
import { ApiService } from '../../api.service';
import {AvailableTagsComponent} from '../../tags/available-tags/available-tags.component';
import {TaggedBaseComponent} from '../../tags/tagged-base/tagged-base.component';

@Component({
    selector: 'app-list-notes',
    templateUrl: './list-notes.component.html',
    styleUrls: ['./list-notes.component.css']
})
export class ListNotesComponent extends TaggedBaseComponent implements OnInit {

    public notes: any;
    public loaded = false;
    public currentsorting: string = 'added';
    public sortingOrder;
    constructor(  private apiService: ApiService ) {
        super('notes');
        this.sortingOrder = 'up';
    }

    ngOnInit() {
        this.getNotes();
    }

    getNotes() {
        this.apiService.getAll('notes').subscribe(
            (value) => {
                this.loaded = true;
                this.notes = value;
                this.filtered = this.notes;
                this.sortBy(this.currentsorting);
            }
        );
    }

    deleteNote(id) {
        const confirmed = window.confirm('Are you sure?');
        if (confirmed) {
            this.apiService
                .deleteByID('notes', id)
                .toPromise()
                .then(
                    () => {
                        this.getNotes();
                    },
                    () => {
                        alert('deletion failed');
                    }
                );
        }
    }

    sortBy(attribute: string) {
        if (attribute === this.currentsorting) {
            this.sortingOrder = this.sortingOrder === 'up' ? 'down' : 'up';
        } else {
            this.sortingOrder = 'up';
        }
        this.currentsorting = attribute;

        this.filtered.sort((a, b) => {
            if (this.sortingOrder === 'up') {
                return a[attribute] > b[attribute] ? 1 : -1;
            }
            return b[attribute] > a[attribute] ? 1 : -1;
        });

    }
}



// WEBPACK FOOTER //
// ./src/app/notes/list-notes/list-notes.component.ts